import NotifyMe from "../modal/notify-me";
import { UpcomingCourseSkeleton } from "./components/loader";
const UpcomingCourse = ({ isLoading }: { isLoading: boolean }) => {
  if (isLoading) return <UpcomingCourseSkeleton />;
  return (
    <div className="container my-12 flex flex-col items-start justify-between gap-4 bg-blue-100 p-6 lg:my-36 lg:flex-row lg:items-center lg:gap-8 lg:p-10">
      <h2 className="text-primary text-center text-3xl font-semibold lg:text-7xl">
        Upcoming{" "}
        <span className="font-vollkorn font-normal italic">Courses</span>{" "}
      </h2>
      <NotifyMe />
    </div>
  );
};

export default UpcomingCourse;
